import { useEffect } from "react";
import { appStore } from "@/app/store/appStore";

const DynamicStyleComponent = () => {
	const appCode = appStore((state) => state.appCode);

	document.body.id = `${appCode}_body`;
	useEffect(() => {
		import("../../../fonts.css")
			.then(() => console.log("fonts loaded successfully"))
			.catch((error) => console.error("Failed to load fonts", error));

		import(`../../../styles/${appCode}.scss`)
			.then(() => console.log(`Stylesheet ${appCode}.css loaded successfully`))
			.catch((error) => console.error(`Failed to load stylesheet ${appCode}.css`, error));
	}, [appCode]);
	return <></>; // В этом компоненте нет необходимости выводить какой-либо контент на экран
};

export default DynamicStyleComponent;
